import React from 'react';
import PropTypes from 'prop-types';
import {reduxForm, Field} from 'redux-form';
import { useTranslation } from 'react-i18next';

let LoginForm = (props) => {
    const { t } = useTranslation();
    const {handleSubmit, pristine, submitting} = props;

    return (
        <div className="form">
            <form onSubmit={handleSubmit}>
                <Field component="input" type="text" name="email" placeholder={t("login.emailInputFieldPlaceholder")} required/>
                <Field component="input" type="password" name="password" placeholder={t("login.passwordInputFieldPlaceholder")} required/>
                <button type="submit" disabled={pristine || submitting }>{t("login.loginFormSubmitButtonText")}</button>
            </form>
        </div>
    )
};

LoginForm.propTypes = {
    onSubmit: PropTypes.func
};

LoginForm = reduxForm({
    form:'loginForm',
    destroyOnUnmount:false,
})(LoginForm);

export default LoginForm;